import React, { useEffect, useState } from 'react';
import { Button } from '@lwt-helix/buttons';
import Select from '@lwt-helix/select';
import { CustomInput, Label } from '@lwt-helix/controls';
import { FormGroup } from '@lwt-helix/form';
import {
    terms as nt,
    frequencyOptions,
    FREQUENCY_NEVER
} from '../../../../constants/notifications';
import Loader from '@lwt-helix/loader';
import { ToastContainer } from '@lwt-helix/toast';
import { showToast, toastTypes } from '../../../helpers/toast';
import { useNotificationSettings, useSaveNotificationSettings } from '../../../../service/hooks/useNotificationSettings';
import { toastMessages } from '../../../../constants';

const Notifications = () => {

    const { data: initialState, isLoading, isFetching } = useNotificationSettings();
    const saveSettings = useSaveNotificationSettings();
    const [toast, setToast] = useState({ toastProps: null });
    const [savedAgentsChecked, setSavedAgentsChecked] = useState(false);
    const [selectedFrequency, setSelectedFrequency] = useState(FREQUENCY_NEVER);

    useEffect(() => {
        if (initialState) {
            setSavedAgentsChecked(initialState.checkbox);
            setSelectedFrequency(initialState.frequency);
        }
    }, [initialState]);

    const isChanged = initialState && (savedAgentsChecked !== initialState.checkbox ||
        selectedFrequency.value !== initialState.frequency.value);

    const handleFrequencyChange = (option) => {
        const newFrequency = option || FREQUENCY_NEVER;
        setSelectedFrequency(newFrequency);
        setSavedAgentsChecked(newFrequency.value !== FREQUENCY_NEVER.value);
    };

    const handleSavedAgentsChecked = (e) => {
        setSavedAgentsChecked(e?.target?.checked);
        if (!e?.target?.checked) {
            setSelectedFrequency(FREQUENCY_NEVER);
        }
    };

    const handleSave = () => {
        saveSettings.mutate(
            { selectedFrequency, hasSettings: initialState?.hasSettings, id: initialState?.id },
            {
                onSuccess: () => showToast(toastTypes.success, toastMessages.success.successfullySaved, setToast),
                onError: () => showToast(toastTypes.error, toastMessages.error.saveFailed, setToast)
            }
        );
    };

    if (isLoading) return <Loader />;

    return (
        <>
            <div className="p-3">
                <div className="d-flex align-items-center mb-2">
                    <h4 className="m-0 text-start font-weight-bold">
                        {nt.notifications}
                    </h4>
                </div>
                <p className="mb-3 text-start text-muted">
                    {nt.notificationsIntro}
                </p>
                <div>
                    <h6 className="text-start font-weight-bold">
                        {nt.notificationsBrokerUpdates}
                    </h6>
                </div>
                <div className="row align-items-start pb-0">
                    <div className="col-md-8 col-xl-9 pl-4">
                        <FormGroup>
                            <div className="d-flex align-items-start">
                                <div className="me-2">
                                    <CustomInput
                                        dataLwtId="saved-agents-checkbox"
                                        id="saved-agents-checkbox"
                                        type="checkbox"
                                        checked={savedAgentsChecked}
                                        onClick={handleSavedAgentsChecked}
                                        disabled={selectedFrequency.value === FREQUENCY_NEVER.value}
                                    />
                                </div>
                                <div className="flex-grow-1 text-start">
                                    <div className="font-weight-bold">
                                        {nt.savedAgents}
                                    </div>
                                    <div className="text-muted mt-1">
                                        {nt.notificationsSavedAgentsDescription}
                                    </div>
                                </div>
                            </div>
                        </FormGroup>
                    </div>
                    <div className="col-md-4 col-xl-3 text-start">
                        <FormGroup>
                            <Label className="font-weight-bold text-start d-block mb-2" dataLwtId='lbl-receive-notifications'>
                                {nt.receiveNotifications}
                            </Label>
                            <Select
                                dataLwtId="notifications-frequency-select"
                                options={frequencyOptions}
                                value={selectedFrequency}
                                onChange={handleFrequencyChange}
                                placeholder={selectedFrequency.label}
                                isClearable={false}
                            />
                        </FormGroup>
                    </div>
                </div>
                <hr />
                <div className="d-flex justify-content-end">
                    <Button
                        dataLwtId="save-notification-settings"
                        color="primary"
                        disabled={!isChanged || saveSettings.isPending || isFetching}
                        onClick={handleSave}
                    >
                        {nt.saveChanges}
                    </Button>
                </div>
            </div>
            <ToastContainer
                dataLwtId="toast"
                toastProps={toast.toastProps}
                position={'toast-bottom-right'}
            />
        </>
    );
};

export default Notifications;
